import { Modal } from "components";
import { useState } from "react";
import { useLocation } from "react-router-dom";

import Login from ".";

export default function LoginModal() {
  const { pathname } = useLocation();
  const [open, setOpen] = useState(false);

  const onClose = () => setOpen(false);
  const onOpen = () => setOpen(true);

  return (
    <>
      <button
        className="h-10 w-20 rounded-lg flex justify-center items-center font-semibold text-sm tracking-wider text-primary bg-primary/[15%] hover:bg-primary hover:text-white"
        onClick={onOpen}
      >
        LOGIN
      </button>
      <Modal widthCSS="max-w-md" classes="!px-10 !pb-10" isOpen={open} onClose={onClose}>
        <Login as="modal" href={pathname} />
      </Modal>
    </>
  );
}
